export const GENERATE_PROPOSAL_BULLET_TABS = 'generate-proposal-bullet-tabs';

export const PROPOSAL_GEN_STEP_HEADER_TEST_ID = 'step-header-test-id';
export const PROPOSAL_GEN_STEP_HEADER_TITLE_TEST_ID = 'step-title-test-id';
export const PROPOSAL_GEN_STEP_HEADER_INFO_TEST_ID = 'step-info-test-id';

export const OUTDATED_FILES_MODAL_TEST_ID = 'outdated-files-modal-test-id';
export const OUTDATED_FILES_MODAL_TITLE_TEST_ID = 'outdated-files-modal-title-test-id';
export const OUTDATED_FILES_MODAL_MESSAGE_TEST_ID = 'outdated-files-modal-message-test-id';
export const OUTDATED_FILES_MODAL_BUTTON_TEST_ID = 'outdated-files-modal-button-test-id';

// First step
export const FIRST_STEP_TEST_ID = 'first-step';

export const INCLUDE_RATES_CHECKBOX = 'include-rates';
export const INCLUDE_BC_CHECKBOX = 'include-bc';
export const INCLUDE_RATES_BC_CHECKBOX = 'include-rates-bc';
export const INCLUDE_PLAN_HIGHLIGHTS_CHECKBOX = 'include-plan-highlights';
export const SHOW_ALL_PRODUCT_ATTRIBUTES_OPTION = 'show-all-option';
export const SHOW_ONLY_PLAN_HIGHLIGHTS_OPTION = 'show-only-plan-highlights-option';

export const INCLUDE_RATE_SHEET_OPTION_TEST_ID = 'include-rate-sheet-option';
export const INCLUDE_PRODUCT_LOGO_OPTION_TEST_ID = 'include-product-logo-option';
export const INCLUDE_RATE_SHEET_BC_OPTION_TEST_ID = 'include-rate-sheet-bc-option';
export const INCLUDE_RATE_SHEET_PLAN_HIGHLIGHTS_OPTION_TEST_ID = 'include-rate-sheet-plan-highlights-option';
export const INCLUDE_PLAN_DETAILS_OPTION_TEST_ID = 'include-plan-details-option';
export const INCLUDE_RATES_BLOCK_OPTION_TEST_ID = 'include-rates-block-option';
export const INCLUDE_BC_OPTION_TEST_ID = 'include-bc-option';
export const SHOW_ALL_PRODUCT_ATTRIBUTES_OPTION_TEST_ID = 'show-all-product-attributes-option';
export const SHOW_ONLY_PLAN_HIGHLIGHTS_OPTION_TEST_ID = 'show-only-plan-highlights-option';

// Second step
export const SECOND_STEP_TEST_ID = 'second-step';

export const CART_ITEMS_ORDER_OPTION = 'cart-items-order-option';
export const A_Z_ORDER_OPTION = 'a-z-order-option';
export const DISPLAY_ORDER_OPTION = 'display-order-option';
export const RATES_LOW_TO_HIGH_OPTION = 'rates-low-to-high-order-option';
export const RATES_HIGH_TO_LOW_OPTION = 'rates-high-to-low-order-option';

export const CART_ITEMS_ORDER_OPTION_TEST_ID = 'cart-items-order-option-test-id';
export const A_Z_ORDER_OPTION_TEST_ID = 'a-z-order-option-test-id';
export const DISPLAY_ORDER_OPTION_TEST_ID = 'display-order-option-test-id';
export const RATES_LOW_TO_HIGH_OPTION_TEST_ID = 'rates-low-to-high-order-option-test-id';
export const RATES_HIGH_TO_LOW_OPTION_TEST_ID = 'rates-high-to-low-order-option-test-id';

// Proposal ready page
export const DOWNLOAD_PDF_TILE_TEST_ID = 'proposal-ready-download-pdf-tile-test-id';
export const DOWNLOAD_XLSX_TILE_TEST_ID = 'proposal-ready-download-xlsx-tile-test-id';
export const SHARE_PROPOSAL_TILE_TEST_ID = 'share-proposal-tile-test-id';
export const BACK_TO_PROPOSAL_BTN_TEST_ID = 'back-to-proposal-btn-test-id';
export const REGENERATE_PROPOSAL_BTN_TEST_ID = 'regenerate-proposal-btn-test-id';
export const PROPOSAL_READY_SPINNER_TEST_ID = 'proposal-ready-spinner-test-id';
export const PROPOSAL_READY_INITIAL_SPINNER_TEST_ID = 'proposal-ready-initial-spinner-test-id';

//   Share proposal modal
export const SHARE_PROPOSAL_FORM_ID = 'share-proposal-form-id';
export const SHARE_PROPOSAL_MODAL_TEST_ID = 'share-proposal-modal-test-id';
export const PRIMARY_EMAIL_INPUT_TEST_ID = 'primary-email-input-test-id';
export const ADD_CC_BUTTON_TEST_ID = 'add-cc-button-test-id';
export const CC_EMAIL_FIELD_TEST_ID = 'cc-email-field-test-id';
export const DELETE_CC_BUTTON_TEST_ID = 'delete-cc-button-test-id';
export const MESSAGE_INPUT_TEST_ID = 'message-input-test-id';
export const EMAIL_SENT_TOAST_TEST_ID = 'email-sent-toast-test-id';
